import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

import { useDashboardFilterFields } from './hooks/useDashboardFilterFields';

export const DashboardFilterForm: React.FC = () => {
  const fields = useDashboardFilterFields({ resetDependentOnChange: true });

  return <FilterFields fields={fields} />;
};
